import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ApexLogoComponent } from "@components/apex-logo/apex-logo.component";
import { AdElDirective } from "../../directives/ad-el/ad-el.directive";

/**
 * Site Footer
 *
 * Global footer rendered on every page (placed in the app component after
 * the router outlet). Ported from the handoff Footer component.
 */
@Component({
  selector: "site-footer",
  templateUrl: "./site-footer.component.html",
  styleUrls: ["./site-footer.component.scss"],
  host: { adComp: "" },
  imports: [AdElDirective, ApexLogoComponent, RouterLink],
})
export class SiteFooterComponent {}
